import { render, staticRenderFns } from "./SpinnerSettings.vue?vue&type=template&id=71ce4d44&scoped=true"
import script from "./SpinnerSettings.vue?vue&type=script&lang=js"
export * from "./SpinnerSettings.vue?vue&type=script&lang=js"
import style0 from "./SpinnerSettings.vue?vue&type=style&index=0&id=71ce4d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce4d44",
  null
  
)

export default component.exports